import { get } from '@bigyouth/base'
import emitter from '../utils/emitter'

export default {
  name: 'tabs',

  ui: {
    'buttons[]': '[js-tabs-button]',
    dropdown: '[js-tabs-dropdown]',
    current: '[js-tabs-current]',
    currentTxt: '[js-tabs-current-txt]',
  },

  events: [
    {
      on: 'click',
      target: 'buttons',
      handle ({ target }) {
        const tab = target.dataset.tab

        if (this.ui.current && window.innerWidth < 768) {
          this.ui.currentTxt.innerHTML = target.innerHTML
          this.ui.dropdown.classList.remove('is-active')
          this.ui.current.classList.remove('is-active')
        }

        // remove active classes
        get('[js-tabs-panel].is-active', this.el).classList.remove('is-active')
        get('[js-tabs-button].is-active', this.el).classList.remove('is-active')

        // add actives ones
        const currentPanel = get(`[js-tabs-panel][data-tab="${tab}"]`, this.el)

        target.classList.add('is-active')
        currentPanel.classList.add('is-active')

        emitter.trigger('stopScriptAnim')
        emitter.trigger('autoPlayScriptAnim', { activeTab: tab, changeTab: true })
      },
    },
  ],

  componentDidMount () {
    if (this.ui.current) {
      this.ui.current.addEventListener('click', () => {
        if (window.innerWidth < 768) {
          this.ui.dropdown.classList.toggle('is-active')
          this.ui.current.classList.toggle('is-active')
        }
      })
    }
  },
}
